module.exports = __webpack_public_path__ + "static/media/website-tuvototuidioma.3cf98100.png";